export default {
  common: {
    clearAll: 'נקה הכל',
    required: 'נדרש',
    restart: 'הפעל מחדש'
  },
  createUser: {
    acceptTermsAndConditions: 'קבל את התנאים וההתניות',
    alreadyHaveAccount: 'כבר יש לך חשבון? %{pre}הורדה%{post}',
    checkEmail: 'בינתיים, הורד את Metrica Play למחשב שלך',
    clubCompany: 'ארגון/מועדון',
    createdSuccessfully:
      'ההרשמה מוצלחת! בדוק את הדוא"ל הרשום שלך לקבלת קישור לאימות. (בדוק תיקיית דואר זבל)',
    email: 'דואר אלקטרוני',
    invalidEmail: 'דואר אלקטרוני לא חוקי',
    job: 'תפקיד/משרה',
    lastName: 'שם משפחה',
    name: 'שם פרטי',
    noCustomOption: 'אפשרות לא זמינה',
    noMatches: 'אין התאמות, כתוב אפשרות משלך',
    password: 'סיסמה',
    passwordsDontMatch: 'הסיסמאות אינן תואמות',
    passwordInvalid: 'הסיסמה אינה עומדת בדרישות',
    passwordRequirements: {
      minLength: 'לפחות %{count} תווים',
      uppercase: 'אות גדולה אחת',
      lowercase: 'אות קטנה אחת',
      number: 'ספרה אחת (0-9)',
      maxLength: 'לכל היותר %{count} תווים'
    },
    phone: 'טלפון',
    phoneCode: 'מדינה',
    proceed: 'המשך',
    repeatPassword: 'חזור על סיסמה',
    searchPhoneCode: 'חיפוש…',
    seeTermsAndConditions: 'ראה תנאים והגבלות',
    signAgreement:
      'הרשמה לחשבון ב-Metrica Sports אומרת שאתה מסכים ל-%{pre1}מדיניות הפרטיות%{post1} ול-%{pre2}תנאי השירות%{post2}',
    signUpHere: 'צור את חשבונך כדי להתחיל.',
    sport: 'ספורט',
    submitting: 'מתחיל...',
    title: 'התחילו עם %{product}',
    userKeyField: 'יש לך קוד פרומו או מפתח משתמש? מלא שדה זה'
  },
  error: {
    downloadPlay: 'אם כבר יש לך חשבון, הורד את הגרסה האחרונה של Play והיכנס.',
    emailTaken: 'דוא"ל זה כבר נלקח',
    fieldTooLong: 'חלק מהשדות ארוכים מדי. קצר אותם ונסה שוב',
    oops: 'אופס!',
    restart: 'נראה שאתה מנסה להיכנס למשהו שאנחנו עדיין מפתחים...',
    tryAgain: 'נסה שוב, אם שגיאה זו תמשיך, צור קשר עם צוות התמיכה של Metrica Sports',
    userKey: 'המפתח אינו תקף. בדוק את המפתח ונסה שוב או מחק את השדה להשלמת הרישום'
  },
  invitation: {
    acceptButton: 'אני מקבל את השינוי בחשבון שלי',
    accepting: 'מקבל...',
    cancelButton: 'דחה',
    description1:
      'כאשר תתווסף לחשבון החדש של Metrica Sports, בעלות על חשבון Metrica Sports הקיים שלך (והמידע המכיל בו) תועבר ותוקצה לבעל החשבון החדש של Metrica Sports. כל המידע והנתונים המכילים כרגע בחשבון Metrica Sports שלך, וכל מידע או נתון שנשמר לאחר שתקבל את שינוי החשבון, יהיו גלויים וזמינים לבעל החשבון החדש של Metrica Sports ולכל מנהל(ים) בחשבון זה לשימוש ולשיתוף עם אחרים על פי שיקול דעתו של בעל החשבון.',
    description2: 'על ידי לחיצה על "אני מקבל/ת את שינוי החשבון שלי" את/ה מסכים/ה ומאשר/ת את הבא:',
    list1: 'מידע החשבון הקיים שלך יועבר לחשבון החדש של Metrica Sports.',
    list2:
      'כל מידע החשבון שהועבר לחשבון Metrica Sports החדש שלך מהחשבון הנוכחי שלך יכול להינהל על ידי בעל החשבון החדש ו/או המנהל(ים).',
    list3:
      'בחשבון החדש של Metrica Sports, התפקיד שלך יהיה "חבר". לא יהיו לך עוד הרשאות של בעלים או מנהל מהחשבון הנוכחי שלך.',
    list4:
      'תירש את ההגדרות הקיימות של חשבון Metrica Sports החדש שלך, שיכולות להיות יותר או פחות מגבילות בהתאם לתפקיד שלך בחשבון, וההגדרות שלך יכולות להיות מנוהלות על ידי בעלים החדש או המנהל(ים) של חשבון Metrica Sports.',
    list5:
      'הגדרותיך הנוכחיות עשויות להשתנות אם הן נוגדות את הגדרות החשבון בחשבון החדש שאליו אתה מצטרף.',
    list6: 'ייתכן שהחשבון החדש שלך לא יספק גישה לכל התכונות שיש לך בחשבון הנוכחי שלך.',
    list7:
      'לא ניתן לבטל את העברת החשבון שלך לאחר שתתחיל בה, וכל מידע החשבון שלך יישאר בחשבון יחיד.',
    list8:
      'על ידי לחיצה על "אני מקבל/ת את שינוי החשבון שלי", תהפוך לחבר מנוהל בחשבון של %{pre1}%{email}%{post1} ותסכים ל%{pre2}תנאי השירות%{post2} ול%{pre3}הצהרת הפרטיות%{post3} של Metrica Sports.',
    subtitle:
      'בקבלת ההזמנה החדשה הזו לחשבון של Metrica Sports, תתווסף לחשבון נוסף של Metrica Sports.',
    title: 'הזמנה'
  },
  jobs: {
    academyDirector: 'מנהל אקדמיה',
    assistantCoach: 'עוזר מאמן',
    dataAnalyst: 'אנליסט נתונים',
    doctor: 'רופא',
    formerPlayer: 'שחקן לשעבר',
    goalkeeperCoach: 'מאמן שוער',
    headCoach: 'מאמן',
    journalist: 'עִתוֹנָאִי',
    other: 'אחר',
    performance: 'ביצועים וכושר',
    player: 'שחקן',
    scout: 'צופה',
    sportsDirector: 'מנהל ספורט',
    student: 'תלמיד',
    videoAnalyst: 'אנליסט וידאו'
  },
  sports: {
    americanFootball: 'פוטבול אמריקאי',
    baseball: 'בייסבול',
    basketball: 'כדורסל',
    fieldHockey: 'הוקי שדה',
    football: 'כדורגל/כדורגל',
    futsal: 'פוטסאל',
    gaelicFootball: 'כדורגל גאלי',
    handball: 'כדוריד',
    iceHockey: 'הוקי קרח',
    lacrosse: 'לקרוס',
    netball: 'נטבול',
    other: 'אחר',
    padel: 'פאדל',
    rugby: 'רוגבי',
    tennis: 'טניס',
    volleyball: 'כדורעף'
  }
}
